// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/iconfont/iconfont.css
// module id = 1082
// module chunks = 2